import React from 'react'
import PropTypes from 'prop-types'
import {Table} from 'semantic-ui-react'
import css from './ReportRow.scss'
import Checkbox from "../SF/Checkbox"

/**
 * Represents a single row in the files table in the Data Extracts Tenant Admin page. This table
 * allows a tenant to configure which files (aka reports) to include in data extracts.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} A single row of the files table in the tenant admin Data Extracts page
 */
const ReportRow = (props) => {
    return (
        <Table.Row className={css['report-row']}>
            <Table.Cell>
                <div className={css['checkbox-container']}>
                    <Checkbox className={css['checkbox']}
                              id={`report-checkbox-${props.display_name.replace(/\s+/g, '')}`}
                              data-testid={`report-checkbox-${props.display_name.replace(/\s+/g, '')}`}
                              ariaLabel={props.display_name.replace(/\s+/g, '')}
                              onChange={() => props.onChange(props.index, !props.enabled)}
                              checked={props.enabled}/>
                </div>
            </Table.Cell>
            <Table.Cell className={css['display-name']}>
                <span>{props.display_name}</span>
            </Table.Cell>
            <Table.Cell className={css['description']}>
                <span>{props.description}</span>
            </Table.Cell>
        </Table.Row>
    )
}

ReportRow.propTypes = {
    display_name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number
}

export default ReportRow
